import api from "../utils/axios";

export async function getVisitedProducts() {
  try {
    const res = await api.get(`/auth/visitedProducts`);
    return res.data.products;
  } catch (error) {
    console.error("visitedProducts fetch error:", error);
    throw error;
  }
}


export async function addVisitedProduct(item) {
  const check = await api.fetch(
    `/visitedProducts?userId=${item.userId}&product.id=${item.product.id}`,
  );

  const exists = await check.json();

  if (exists.length > 0) {
    return exists[0];
  }

  const response = await api.fetch(`/visitedProducts`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(item),
  });

  return response.json();
}

export async function removeVisitedProduct(id) {
  const response = await api.fetch(`/visitedProducts/${id}`, {
    method: "DELETE",
  });

  return response.ok;
}
